exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.orderCustomer .el-dialog .el-dialog__body {\n  padding: 0px 30px 20px 20px !important;\n}\n.label-style {   \n  text-align:left;  \n  margin-top:15px;\n}\n.warrantyCard{\n  width: 75%;\n  float: none;\n  margin:0 auto;\n}\n.a-style {\n  font-size:14px;\n  font-weight:bold;\n  padding-right:30px;\n}\n.eror .el-input__inner {\n  /* border: none; */\n  padding: 0;\n}\n.changeform .el-input {\n  width: 100%;\n}\n.changeform .el-input__inner {\n  width: 100%;\n}\n", ""]);

// exports
